module.exports = __webpack_public_path__ + "img/st-johnstone-fc.9d459efe.png";